export enum RelationshipType {
  FATHER = "FATHER",
  MOTHER = "MOTHER",
  GUARDIAN = "GUARDIAN",
  GRANDPARENT = "GRANDPARENT",
  SIBLING = "SIBLING",
  OTHER = "OTHER",
}
